export default __webpack_public_path__ + "static/media/tetris.241caa58.png";